// Configuration centralisée de l'API
export const API_BASE_URL = import.meta.env.VITE_API_URL || "http://localhost:8003";

// Debug en mode développement
if (import.meta.env.DEV) {
  console.log("=== Configuration API ===");
  console.log("VITE_API_URL:", import.meta.env.VITE_API_URL);
  console.log("API_BASE_URL:", API_BASE_URL);
  console.log("Mode:", import.meta.env.MODE);
  console.log("========================");
}

// Helper pour les headers d'authentification
export function getAuthHeaders(): Record<string, string> {
  const token = localStorage.getItem("auth_token");
  if (!token) return {};
  
  // Nettoyer le token (enlever "Bearer " en double si présent)
  let cleanToken = token.trim();
  while (cleanToken.toLowerCase().startsWith("bearer ")) {
    cleanToken = cleanToken.slice(7).trim();
  }
  
  return {
    Authorization: `Bearer ${cleanToken}`,
  };
}

// Helper pour les requêtes API
export async function apiFetch<T = any>(
  endpoint: string,
  options?: RequestInit
): Promise<T> {
  const url = `${API_BASE_URL}${endpoint}`;
  
  const response = await fetch(url, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      ...getAuthHeaders(),
      ...options?.headers,
    },
  });

  const data = await response.json().catch(() => ({}));
  
  if (!response.ok) {
    const errorMessage = (data as any)?.detail || `Erreur ${response.status}`;
    throw new Error(errorMessage);
  }

  return data as T;
}
